/* eslint-disable id-length */

import { serviceName } from '../resources/serviceConstants';

const BUDGET_CHANGE_REQUESTS = '/v1/budget-change-requests';

const buildQueryString = (params = {}) => {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    searchParams.append(key, value);
  });

  const query = searchParams.toString();
  return query ? `?${query}` : '';
};

const buildBudgetChangeRequest = (url, method = 'get', payload) => ({
  url,
  method,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload !== undefined ? { payload } : {}),
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

export const getBudgetChangeRequests = (query = {}) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}${buildQueryString(query)}`,
);

export const listBudgetChangeRequests = (payload = {}) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/list`,
  'post',
  payload,
);

export const getBudgetChangeRequestById = (id) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/${id}`,
);

export const createBudgetChangeRequest = (payload) => buildBudgetChangeRequest(
  BUDGET_CHANGE_REQUESTS,
  'post',
  payload,
);

export const bulkUpdateBudgetChangeRequestStatus = (payload) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/bulk-action`,
  'post',
  payload,
);

export const updateBudgetChangeRequest = (id, payload) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/${id}`,
  'put',
  payload,
);

export const deleteBudgetChangeRequest = (id) => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/${id}`,
  'delete',
);

export const getBudgetChangeRequestStatuses = () => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/masters/statuses`,
);

export const getBudgetChangeRequestCostCategories = () => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/masters/cost-categories`,
);

export const getBudgetChangeRequestResourceTypes = () => buildBudgetChangeRequest(
  `${BUDGET_CHANGE_REQUESTS}/masters/resource-types`,
);
